import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import TeaserInfo from '../../../TeaserInfo'
import { EventProps } from '../EventTypes'
import Event from '..'
import { SpacingProps } from '../../../utils/styling/StylingHelper'
import { mapSpaceValue } from '../../../Layouts/LayoutUtils'
import TopLabel, { TopLabelProps } from '../../TopLabel'
import { HeadlineProps } from '../../Match/MatchCard'

export type EventCardProps = {
    headlineProps?: HeadlineProps
    eventProps: EventProps
    /**
     * callback when the 'Livestream' button gets pressed
     */
    onPressVideoButton?: () => void
    /**
     * link for the button
     */
    videoButtonHref?: string
    /**
     * text for the button
     */
    videoButtonText?: string
} & TestID &
    Pick<SpacingProps, 'spaceY' | 'spaceTop' | 'spaceBottom'> &
    TopLabelProps

const getPaddingTop = (type: EventProps['type']): string => {
    if (type === 'PRE') return '10px'
    if (type === 'LIVE') return '6px'
    if (type === 'POST') return '6px'
    return '10px'
}

const EventCard: FunctionComponent<EventCardProps> = ({
    headlineProps,
    eventProps,
    topLabel,
    testID,
    spaceY,
    spaceBottom,
    spaceTop,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText,
}): ReactElement => (
    <Grid
        backgroundColor="pearl"
        border="1px"
        borderColor="moon-2"
        borderRadius={4}
        testID={testID}
        noExpand
        marginY={mapSpaceValue(spaceY)}
        marginBottom={mapSpaceValue(spaceBottom)}
        marginTop={mapSpaceValue(spaceTop)}
    >
        {topLabel ? <TopLabel topLabel={topLabel} onPress={eventProps.onPressEvent} /> : null}
        <Grid noExpand paddingTop={topLabel ? 0 : '6px'}>
            {headlineProps ? (
                <Grid paddingX={5} paddingTop="6px">
                    <Touchable onPress={headlineProps.onPressHeadline}>
                        <TeaserInfo
                            name={headlineProps.text}
                            imageUrl={headlineProps.imageUrl}
                            alt={headlineProps.alt}
                            hideTagImage={headlineProps.hideTagImage}
                        />
                    </Touchable>
                </Grid>
            ) : (
                <Grid />
            )}
            <Event
                borderRadius={4}
                paddingTop={getPaddingTop(eventProps.type)}
                {...eventProps}
                onPressVideoButton={onPressVideoButton}
                videoButtonHref={videoButtonHref}
                videoButtonText={videoButtonText}
            />
        </Grid>
    </Grid>
)

export default memo(EventCard)
